import React, { type PropsWithChildren } from 'react'

import styles from './footer-mobile.module.scss'

export const FooterMobile: React.FC<PropsWithChildren> = ({ children }) => {
    return <footer className={styles['footer-mobile']}>{children}</footer>
}
